import InvisiButton from '../InvisiButton/InvisiButton'
import classes from './MultiselectDropdown.module.scss'
import { FiX } from 'react-icons/fi'

export interface Props {
  onClear: () => void
}

const MultiselectClearButton = ({ onClear }: Props) => (
  <InvisiButton
    hasHoverEffect
    label='Clear'
    onClick={onClear}
  >
    <span className={classes.clearWrapper}>
      <FiX
        aria-hidden
        size={16}
      />
      Clear
    </span>
  </InvisiButton>
)

export default MultiselectClearButton
